import Table from "PFComponents/table";
import { CustomValueImportRowsResponse } from "PFCore/services/admin/imports/fetch_custom_value_import_rows";
import { CustomValueImportRow } from "PFTypes";
import React from "react";

import { useColumnsGenerator } from "./hooks/use_columns_generator";
import css from "./import_data_table_page.module.scss";

const COUNTERS_SIZE = 73;
const PAGINATION_SIZE = 38;

type ImportDataTableProps = {
  rowsData: CustomValueImportRowsResponse;
  currentPage: number;
  setCurrentPage: (page: number) => void;
};

export const ImportDataTable = ({
  rowsData,
  currentPage,
  setCurrentPage
}: ImportDataTableProps): JSX.Element => {
  const generateColumns = useColumnsGenerator();

  return (
    <Table<CustomValueImportRow>
      tableData={rowsData.entries || []}
      generateColumns={generateColumns}
      paginationOptions={{
        totalPages: rowsData?.meta.totalPages || 1,
        currentPage,
        onClick: setCurrentPage,
        className: css.tablePagination
      }}
      bottomElementsSize={COUNTERS_SIZE + PAGINATION_SIZE}
    />
  );
};
